import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const DigitalOperations = {
  Helmet: lazy(() => import('./components/Helmet')),
  QualityAssurance: lazy(() => import('./containers/QualityAssurance')),
  QualityAssurance2: lazyNamed(() => import('./containers/QualityAssurance2'), 'QualityAssurance2'),
  CampaignManagement: lazy(() => import('./containers/CampaignManagement')),

  Approval: {
    CreativesList: lazy(() => import('./containers/Approval/containers/CreativesList')),
    CreativeDraftsPage: lazy(() => import('./containers/Approval/containers/CreativeDraftsPage')),
    Layout: lazy(() => import('./containers/Approval/components/Layout')),
  },

  ScreenshotManagement: {
    Campaigns: lazy(() => import('./containers/ScreenshotManagement/containers/Campaigns')),
    Approvals: lazy(() => import('./containers/ScreenshotManagement/containers/Approvals')),
    Done: lazy(() => import('./containers/ScreenshotManagement/containers/Done')),
    Hidden: lazy(() => import('./containers/ScreenshotManagement/containers/Hidden')),
    Layout: lazy(() => import('./containers/ScreenshotManagement/components/Layout')),
  },
};

export { DigitalOperationStatus } from './types';

export default DigitalOperations;
